import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getOrganization, getOrgBranches, getOrgContactPersons, getOrgJobRoles, getOrgDepts,
    addJobRole, addBranch, addOrgDept, addContactPerson,
    deleteOrgDept, deleteContactPerson, deleteJobRole, deleteBranch, 
} from "../../utils/helper";
import Loader from "../../utils/Loader";
import avatar from "../../assets/img/profile_av.jpg";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { alertError, alertSuccess } from "../../utils/alerts";
import { states } from "../../utils/dataFile";

const INIT_ORG = {
    name: "",
    email: "",
    phone: "",
    state: "",
    address: "",
    country: "",
    industry: "",
    assignedEmail: "",
    status: "",
}

const INIT_ROLE = {
    name: "",
}

const INIT_BRANCH = {
    branch_name: "",
    branch_code: "",
    state: "",
    country: "",
}


const INIT_DEPT = {
    name: "",
    code:"",
}

const INIT_PERSON = {
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    designation: "",
}

export default function ViewOrganization() {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [org, setOrg] = useState(INIT_ORG);
    const [branches, setBranches] = useState(null);
    const [contacts, setContacts] = useState(null);
    const [jobroles, setJobRoles] = useState([]);
    const [departments, setDepts] = useState([]);

    const [newJob, setNewJob] = useState(INIT_ROLE); 
    const [newBranch, setNewBranch] = useState(INIT_BRANCH); 
    const [newDept, setNewDept] = useState(INIT_DEPT); 
    const [newPerson, setNewPerson] = useState(INIT_PERSON); 

    useEffect(() => {
        if(id){
            setLoading(true);
            getOrganization(id)
            .then((res) => { 
                if(res.data.success){
                    setOrg(res.data.data);  
                    setLoading(false)
                }
            })
            .catch((err) => {
                console.log(err?.response?.data?.error)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
        }
    }, [id]);

    
    useEffect(() => {
        getOrgBranches(id)
            .then((res) => {                
                if(res.data.success){
                    setBranches(res.data.data);
                }
            })
            .catch((err) => {
                alertError(err.response.data.message)
            });
    }, [id]); 

    useEffect(() => {
        getOrgContactPersons(id)
            .then((res) => {                
                if(res.data.success){
                    setContacts(res.data.data);
                }
            })
            .catch((err) => {
                alertError(err.response.data.message)
            });
    }, [id]); 

    useEffect(() => {
        getOrgJobRoles(id)
            .then((res) => {                
                if(res.data.success){
                    setJobRoles(res.data.data);
                }
            })
            .catch((err) => {
                alertError(err.response.data.message)
            });
    }, [id]); 

    useEffect(() => {
        getOrgDepts(id)
            .then((res) => {                
                if(res.data.success){
                    setDepts(res.data.data);
                }
            })
            .catch((err) => {
                alertError(err.response.data.message)
            });
    }, [id]); 

    const handleChangeJob = (e) => {
        e.persist();
        setNewJob((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    const handleSubmitJob = async (e) => {
        e.preventDefault();
        if (window.confirm("Note: Are you sure you want to proceed? Click OK to proceed.")) {
            const data = { ...newJob, organization: id };
            if(data.name && data.organization){
                setLoading(true);
                addJobRole(data)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                        window.location.reload()
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err.response)
                    alertError(err.response?.data?.error);
                    setLoading(false);
                });
            };
        } else {alert("Job role creation was canceled!");}
    }

    const handleChangeBranch = (e) => {
        e.persist();
        setNewBranch((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    const handleSubmitBranch = async (e) => {
        e.preventDefault();
        if (window.confirm("Note: Are you sure you want to proceed? Click OK to proceed.")) {
            const data = { ...newBranch, organization: id };
            if(data.branch_name && data.branch_code && data.state && data.country && data.organization){
                setLoading(true);
                addBranch(data)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                        window.location.reload()
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err.response)
                    alertError(err.response?.data?.error);
                    setLoading(false);
                });
            };
        } else {alert("Branch creation was canceled!");}
    }

    const handleChangeDept = (e) => {
        e.persist();
        setNewDept((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    const handleSubmitDept = async (e) => {
        e.preventDefault();
        if (window.confirm("Note: Are you sure you want to proceed? Click OK to proceed.")) {
            const data = { ...newDept, organization: id };
            if(data.name && data.code && data.organization){
                setLoading(true);
                addOrgDept(data)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                        window.location.reload()
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err.response)
                    alertError(err.response?.data?.error);
                    setLoading(false);
                });
            };
        } else {alert("Job role creation was canceled!");}
    }

    const handleChangePerson = (e) => {
        e.persist();
        setNewPerson((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    const handleSubmitPerson = async (e) => {
        e.preventDefault();
        if (window.confirm("Note: Are you sure you want to proceed? Click OK to proceed.")) {
            const data = { ...newPerson, organization: id };
            if(data.contact_name && data.contact_email && data.contact_phone && data.designation && data.organization){
                setLoading(true);
                addContactPerson(data)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                        window.location.reload()
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err.response)
                    alertError(err.response?.data?.error);
                    setLoading(false);
                });
            };
        } else {alert("Job role creation was canceled!");}
    }

    const handleDeleteJob = (kpdid) => {
        if (window.confirm("Note: Are you sure you want to proceed? Click OK to proceed.")) {
            deleteJobRole(kpdid)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    window.location.reload();
                })
                .catch((err) => {
                    alertError(err.response.data.error);
                });
        } else {
            alert("Deletion of job role was canceled!");
        }
    };

    const handleDeleteDept = (theid) => {
        if (window.confirm("Note: Are you sure you want to proceed? Click OK to proceed.")) {
            deleteOrgDept(theid)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    window.location.reload();
                })
                .catch((err) => {
                    alertError(err.response.data.error);
                });
        } else {
            alert("Deletion of department was canceled!");
        }
    };

    const handleDeleteBranch = (theid) => {
        if (window.confirm("Note: Are you sure you want to proceed? Click OK to proceed.")) {
            deleteBranch(theid)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    window.location.reload();
                })
                .catch((err) => {
                    alertError(err.response.data.error);
                });
        } else {
            alert("Deletion of branch was canceled!");
        }
    };

    const handleDeletePerson = (theid) => {
        if (window.confirm("Note: Are you sure you want to proceed? Click OK to proceed.")) {
            deleteContactPerson(theid)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    window.location.reload();
                })
                .catch((err) => {
                    alertError(err.response.data.error);
                });
        } else {
            alert("Deletion of contact person was canceled!");
        }
    };

    return (
        <>
            <h1 className="dash-title"><Link to="/outsourcing/organizations" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link></h1>

            <div className="card mb-0">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            {!loading ?  
                            <div className="profile-view">
                                <div className="profile-img-wrap">
                                    <div className="profile-img">
                                        <img src={avatar} alt="avatar" />
                                    </div>
                                </div>
                            
                                <div className="profile-basic">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <ul className="personal-info">
                                                <li>
                                                    <div className="title">Name of Organization:</div>
                                                    <div className="text">{org?.name && org?.name}</div>
                                                </li>
                                                <li>
                                                    <div className="title">Phone:</div>
                                                    <div className="text"><span>{org.phone && org.phone} </span></div>
                                                </li>
                                                <li>
                                                    <div className="title">Email:</div>
                                                    <div className="text"><span>{org.email && org.email} </span></div>
                                                </li>
                                                <li>
                                                    <div className="title">Address:</div>
                                                    <div className="text"><span>{org.address && org.address} </span></div>
                                                </li>
                                                <li>
                                                    <div className="title">Country:</div>
                                                    <div className="text"><span>{org.country && org.country} </span></div>
                                                </li>
                                                <li>
                                                    <div className="title">Industry:</div>
                                                    <div className="text"><span>{org.industry && org.industry} </span></div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : <Loader /> }
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-6 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body">
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Job Roles 
                                <button type="button" data-toggle="modal" data-target="#jobmodal" className="edit-icon pull-right">
                                    <i className="fa fa-solid fa-plus"></i>
                                </button>
                            </h3>
                            
                            {(org && org.name !=="" && jobroles && jobroles.length > 0) ? 
                            <div className="table-responsive">
                                <table className="table table-nowrap table-bordered table-stripped">
                                    <thead><tr><th>SN</th><th>Name</th><th>Actions</th></tr></thead>
                                    <tbody>
                                        {jobroles && jobroles.map((role,i ) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td>{role.name && role.name}</td>
                                                <td>
                                                    <button 
                                                        // onClick={() => navigateById("/outsourcing/organization", row._id)} 
                                                        className='btn btn-edit mr-2'
                                                        disabled
                                                    >
                                                        Edit
                                                    </button>
                                                    <button 
                                                        onClick={() => handleDeleteJob(role._id)} 
                                                        className='btn btn-delete'
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div> 
                            : <div className="alert alert-danger myerror d-block">No record found</div> }
                        </div>
                    </div>
                </div>

                <div className="col-md-6 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body">
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Departments
                                <button type="button" data-toggle="modal" data-target="#deptmodal" className="edit-icon pull-right">
                                    <i className="fa fa-solid fa-plus"></i>
                                </button>
                            </h3>
                            {(org && org.name !=="" && departments && departments.length > 0) ? 
                            <div className="table-responsive">
                                <table className="table table-nowrap table-bordered table-stripped">
                                    <thead><tr><th>SN</th><th>Name</th><th>Code</th><th>Actions</th></tr></thead>
                                    <tbody>
                                        {departments && departments.map((dept, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td>{dept.name && dept.name}</td>
                                                <td>{dept.code && dept.code}</td>
                                                <td>
                                                    <button 
                                                        // onClick={() => navigateById("/outsourcing/organization", row._id)} 
                                                        className='btn btn-edit mr-2'
                                                        disabled
                                                    >
                                                        Edit
                                                    </button>
                                                    <button 
                                                        onClick={() => handleDeleteDept(dept._id)} 
                                                        className='btn btn-delete'
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div> 
                            : <div className="alert alert-danger myerror d-block">No record found</div>  }
                        </div>
                    </div>
                </div>

                <div className="col-md-6 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body">
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Branches
                                <button type="button" data-toggle="modal" data-target="#branchmodal" className="edit-icon pull-right">
                                    <i className="fa fa-solid fa-plus"></i>
                                </button>
                            </h3>
                            {(org && org.name !=="" && branches && branches.length > 0) ? 
                            <div className="table-responsive">
                                <table className="table table-nowrap table-bordered table-stripped">
                                    <thead><tr><th>SN</th><th>Name</th><th>Code</th><th>State</th><th>Country</th><th>Actions</th></tr></thead>
                                    <tbody>
                                        {branches && branches.map((branch, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td>{branch.branch_name && branch.branch_name}</td>
                                                <td>{branch.branch_code && branch.branch_code}</td>
                                                <td>{branch.state && branch.state}</td>
                                                <td>{branch.country && branch.country}</td>
                                                <td>
                                                    <button 
                                                        // onClick={() => navigateById("/outsourcing/organization", row._id)} 
                                                        className='btn btn-edit mr-2'
                                                        disabled
                                                    >
                                                        Edit
                                                    </button>
                                                    <button 
                                                        onClick={() => handleDeleteBranch(branch._id)} 
                                                        className='btn btn-delete'
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div> 
                            : <div className="alert alert-danger myerror d-block">No record found</div>  }
                        </div>
                    </div>
                </div>

                <div className="col-md-6 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body">
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Contact Persons
                                <button type="button" data-toggle="modal" data-target="#contactmodal" className="edit-icon pull-right">
                                    <i className="fa fa-solid fa-plus"></i>
                                </button>
                            </h3>
                            {(org && org.name !=="" && contacts && contacts.length > 0) ? 
                            <div className="table-responsive">
                                <table className="table table-nowrap table-bordered table-stripped">
                                    <thead><tr><th>SN</th><th>Name</th><th>Email</th><th>Phone</th><th>Designation</th><th>Actions</th></tr></thead>
                                    <tbody>
                                        {contacts && contacts.map((contact, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td>{contact.contact_name && contact.contact_name}</td>
                                                <td>{contact.contact_email && contact.contact_email}</td>
                                                <td>{contact.contact_phone && contact.contact_phone}</td>
                                                <td>{contact.designation && contact.designation}</td>
                                                <td>
                                                    <button 
                                                        // onClick={() => navigateById("/outsourcing/organization", row._id)} 
                                                        className='btn btn-edit mr-2'
                                                        disabled
                                                    >
                                                        Edit
                                                    </button>
                                                    <button 
                                                        onClick={() => handleDeletePerson(contact._id)} 
                                                        className='btn btn-delete'
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div> 
                            : <div className="alert alert-danger myerror d-block">No record found</div>  }
                        </div>
                    </div>
                </div>
            </div>
            

            <div id="jobmodal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">ADD JOB ROLE</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Job Role/Title <span>*</span></label>
                                    <input type="text" name="name" className="form-control" required placeholder="Job Role/Title" 
                                    onChange={handleChangeJob} defaultValue={newJob.name && newJob.name }  disabled={loading} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={loading}
                                        onClick={handleSubmitJob} >Create Job Role</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 

            <div id="branchmodal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">ADD BRANCH</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Branch Name <span>*</span></label>
                                    <input type="text" name="branch_name" className="form-control" required placeholder="Branch Name" 
                                    onChange={handleChangeBranch} defaultValue={newBranch.branch_name && newBranch.branch_name }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Branch Code <span>*</span></label>
                                    <input type="text" name="branch_code" className="form-control" required placeholder="Branch Code" 
                                    onChange={handleChangeBranch} defaultValue={newBranch.branch_code && newBranch.branch_code }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">State <span>*</span></label>
                                    <select className="form-control form-select" name="state" id="state" required 
                                    onChange={handleChangeBranch} defaultValue={newBranch.state && newBranch.state} disabled={loading}>
                                        <option value=''>Select...</option>
                                        {states && states.map((item, i) => (
                                            <option key={i} value={item.label}>{item.label}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Country <span>*</span></label>
                                    <select className="form-control form-select" name="country" id="country" required 
                                    onChange={handleChangeBranch} defaultValue={newBranch.country && newBranch.country} disabled={loading}>
                                        <option value=''>Select...</option>
                                        <option value="Nigeria">Nigeria</option>
                                        <option value="Ghana">Ghana</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={loading}
                                        onClick={handleSubmitBranch} >Create New Branch</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 

            <div id="deptmodal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">ADD DEPARTMENT</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Department Name <span>*</span></label>
                                    <input type="text" name="name" className="form-control" required placeholder="Department Name" 
                                    onChange={handleChangeDept} defaultValue={newDept.name && newDept.name }  disabled={loading} />
                                </div>
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Department Code <span>*</span></label>
                                    <input type="text" name="code" className="form-control" required placeholder="Department Code" 
                                    onChange={handleChangeDept} defaultValue={newDept.code && newDept.code }  disabled={loading} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={loading}
                                        onClick={handleSubmitDept} >Create New Department</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 

            <div id="contactmodal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">ADD CONTACT PERSON</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Contact Person Name <span>*</span></label>
                                    <input type="text" name="contact_name" className="form-control" required placeholder="Contact Person Name" 
                                    onChange={handleChangePerson} defaultValue={newPerson.contact_name && newPerson.contact_name }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Contact Person Email <span>*</span></label>
                                    <input type="text" name="contact_email" className="form-control" required placeholder="Contact Person Email" 
                                    onChange={handleChangePerson} defaultValue={newPerson.contact_email && newPerson.contact_email }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Contact Person Phone <span>*</span></label>
                                    <input type="text" name="contact_phone" className="form-control" required placeholder="Contact Person Email" 
                                    onChange={handleChangePerson} defaultValue={newPerson.contact_phone && newPerson.contact_phone }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Designation <span>*</span></label>
                                    <input type="text" name="designation" className="form-control" required placeholder="Designation" 
                                    onChange={handleChangePerson} defaultValue={newPerson.designation && newPerson.designation }  disabled={loading} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={loading}
                                        onClick={handleSubmitPerson} >Create New Contact Person</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </>
    );
}
